var _circle, _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _mask, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_808)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.475 187.23L329.475 187.231C328.935 190.664 327.058 193.695 324.381 195.569L324.379 195.571C321.252 197.766 317.346 198.395 313.643 197.293C310.449 196.326 306.968 196.916 304.361 198.947L281.412 216.829L277.937 212.243L300.845 194.404L300.85 194.4C303.443 192.37 304.865 189.162 304.728 185.835L304.728 185.827C304.547 181.77 306.351 177.865 309.526 175.39L309.526 175.39C312.191 173.312 315.497 172.422 318.863 172.86C322.216 173.305 325.168 175.031 327.216 177.742C329.171 180.354 330.016 183.805 329.475 187.23Z",
    fill: "#4045A1",
    stroke: "black",
    strokeWidth: 4.66473
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.833 306.725C170.161 313.742 175.971 320.249 182.148 326.247C177.49 329.679 171.85 331.548 166.013 331.548C150.978 331.548 138.75 319.302 138.75 304.249C138.75 295.632 142.755 287.712 149.521 282.572C153.874 290.867 158.952 298.966 164.833 306.725Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1580_808",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 312,
    width: 115,
    height: 92
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.685 319.22H204.498V396.678H104.685V319.22Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13.9942
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1580_808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.357 396.07H105.435L135.424 328.566C142.573 337.586 153.603 343.399 166.012 343.399C170.171 343.399 174.244 342.727 178.103 341.461L202.357 396.07Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 13.9942
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1580_808",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 109,
    width: 60,
    height: 82
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.688 114.573H389.414V185.511H339.688V114.573Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 9.32946
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1580_808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.626 120.874C340.392 120.373 339.793 118.961 340.294 117.718C340.795 116.467 342.207 115.877 343.449 116.378C372.232 128.043 387.696 150.211 389.412 182.274C389.484 183.606 388.456 184.75 387.124 184.821C387.079 184.83 387.035 184.83 386.99 184.83C385.712 184.83 384.639 183.829 384.568 182.533C382.941 152.097 368.889 131.922 341.626 120.874Z",
    fill: "#4045A1",
    stroke: "#4045A1",
    strokeWidth: 9.32946
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M337.228 142.274C335.986 141.774 335.387 140.352 335.888 139.11C336.388 137.867 337.809 137.268 339.043 137.778C357.171 145.117 366.914 159.079 367.996 179.254C368.067 180.594 367.039 181.739 365.707 181.81C365.663 181.819 365.618 181.819 365.573 181.819C364.295 181.819 363.222 180.809 363.151 179.522C362.168 161.126 353.685 148.942 337.228 142.274Z",
    fill: "#4045A1",
    stroke: "#4045A1",
    strokeWidth: 9.32946
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M348.141 179.665C348.213 181.006 347.185 182.15 345.853 182.222C345.808 182.222 345.764 182.222 345.719 182.222C344.441 182.222 343.368 181.221 343.305 179.934C342.841 171.281 338.854 165.551 331.131 162.414C329.888 161.913 329.289 160.501 329.799 159.258C330.3 158.016 331.712 157.417 332.945 157.917C342.465 161.779 347.578 169.091 348.141 179.665Z",
    fill: "#4045A1",
    stroke: "#4045A1",
    strokeWidth: 9.32946
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_1580_808",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.215 107.633C162.515 129.284 144.22 162.283 140.355 199.372C136.491 236.461 147.373 274.601 170.608 305.402C193.843 336.202 227.528 357.141 264.252 363.611C300.975 370.082 337.73 361.553 366.431 339.903L278.823 223.768L191.215 107.633Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.215 107.633C162.515 129.284 144.22 162.283 140.355 199.372C136.491 236.461 147.373 274.601 170.608 305.402C193.843 336.202 227.528 357.141 264.252 363.611C300.975 370.082 337.73 361.553 366.431 339.903L278.823 223.768L191.215 107.633Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 30.6913,
    mask: "url(#path-11-inside-1_1580_808)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDth);
export default __webpack_public_path__ + "static/media/DTH.f5d791fcbe552c8d4d5cf8caf3bedb2a.svg";
export { ForwardRef as ReactComponent };